<template>
  <div style="color:lightgray">
    <v-btn
      text
      icon
      style="float:right"
      @click="closeDrawer"
      v-if="components.nav_drawer.mini_variant==false && components.nav_drawer.expand_on_hover==false"
    >
      <v-icon >mdi-arrow-right</v-icon>
    </v-btn>
    <v-list
      dense
      nav
      class="py-0"
    >
      <v-list-item>
        <v-list-item-icon>
          <v-icon size="35" style="padding-top:10px;color:lightgray">mdi-cart</v-icon>
        </v-list-item-icon>

        <v-list-item-content
          style="padding-left:30px"
        >
          <v-list-item-title><h6 style="padding-bottom:0;margin-bottom:0;color:lightgray"><b>To Get a Quote</b></h6></v-list-item-title>
          <v-list-item-subtitle style="color:gray">Select a Product below</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list-item
        v-for="(item) in items"
        :key="item.title"
        link
        @click="selectProduct(item.index)"
      >
        <v-list-item-icon>
          <v-icon style="color:lightgray">{{ item.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content
          style="padding-left:40px"
        >
          <v-list-item-title style="color:lightgray">{{ item.title }}</v-list-item-title>
          <v-list-item-subtitle style="color:gray">{{ item.subtitle }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>
<script>
  import { mapGetters } from "vuex";

  export default {
    name: "ProductSelection",
    data () {
      return {
        items: [
          { title: 'Motor Insurance', icon: 'mdi-car', subtitle: '(Motor Comprehensive & Full Third Party Insurance Products)', index:1 },
          { title: 'House Insurance', icon: 'mdi-home', subtitle: '(House Owners & Household Goods Insurance Products)', index:2  },
          { title: 'Overseas Travel', icon: 'mdi-airplane', subtitle: '(Overseas Travel Insurance Products)', index:3  },
          //{ title: 'Gadgets Insurance', icon: 'mdi-cellphone', subtitle: '(Insurance for Hand-held devices such as Cellphones)', index:4  },
          { title: 'Muende Bwino', icon: 'mdi-bus', subtitle: '(Local Travel Personal Cover)', index:5  },
        ]
      }
    },
    methods: {
      selectProduct(index){
        this.components.nav_drawer.product_index=index;
        this.components.nav_drawer.mini_variant=false;
        this.components.nav_drawer.expand_on_hover=false
      },
      closeDrawer(){
        this.components.nav_drawer.product_index=0;
        this.components.nav_drawer.mini_variant=true;
        this.components.nav_drawer.expand_on_hover=true;
      }
    },
    computed: {
      ...mapGetters({
        user: "user",
        components: "components"
      })
    }
  }
</script>
